import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import WeatherApp from './WeatherApp';


function App() {
  return (
    <div>
      <WeatherApp defaultCity="Mendoza"/>
      <p className="footer">This project was coded by <a href="https://jpoydesign.com/" target="blank">Julieta Poy </a>and is open-sourced on <a href="https://github.com/jpoygd/weather-app" target="blank">GitHub</a> and hosted on <a href="https://profound-chebakia-f36a3d.netlify.app/" target="blank">Netlify</a></p>
    </div>
      
    
  );
}

export default App;
